export default __webpack_public_path__ + "images/0x7f883da3b0d77978075f7c9c03e1b9f461ca1b8d.png";